export const API_KEYS_SURFACE_PATH = "/api-keys";
export const OEM_API_KEYS_SURFACE_PATH = "/oem/api-keys";

const API_KEYS_SURFACE_DEFAULT_ROLES = new Set(["admin", "admin_staff", "client_admin", "staff"]);

const parseCsvEnv = (value = "") =>
  String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

const envList = (name) => parseCsvEnv(process.env[name]);

const isTruthyEnv = (value) => String(value || "").trim().toLowerCase() === "true";

export const isApiKeysSurfaceEnabled = () =>
  process.env.REACT_APP_API_KEYS_SURFACE_ENABLED !== "false";

const isAllowlistEnabled = () =>
  isTruthyEnv(process.env.REACT_APP_API_KEYS_SURFACE_ALLOWLIST_ENABLED) ||
  envList("REACT_APP_API_KEYS_SURFACE_ALLOWLIST_CLIENT_IDS").length > 0 ||
  envList("REACT_APP_API_KEYS_SURFACE_ALLOWLIST_USER_IDS").length > 0 ||
  envList("REACT_APP_API_KEYS_SURFACE_ALLOWLIST_EMAILS").length > 0;

const normalizeEmail = (email = "") => String(email || "").trim().toLowerCase();
const normalizeId = (value = "") => String(value ?? "").trim();

const hasRuntimePermission = (user) =>
  Array.isArray(user?.permissions) &&
  user.permissions.some((permission) =>
    [
      API_KEYS_SURFACE_PATH,
      OEM_API_KEYS_SURFACE_PATH,
      "api_keys_surface",
      "oem_api_keys_surface",
      "api_keys.read",
    ].includes(String(permission || "").trim())
  );

export const isApiKeysSurfaceAllowlisted = (user) => {
  if (!user || !isAllowlistEnabled()) return false;

  const clientIds = new Set(envList("REACT_APP_API_KEYS_SURFACE_ALLOWLIST_CLIENT_IDS"));
  const userIds = new Set(envList("REACT_APP_API_KEYS_SURFACE_ALLOWLIST_USER_IDS").map(normalizeId));
  const emails = new Set(envList("REACT_APP_API_KEYS_SURFACE_ALLOWLIST_EMAILS").map(normalizeEmail));

  const clientMatch = clientIds.size === 0 || clientIds.has(normalizeId(user.client_id));
  const userMatch = userIds.size === 0 || userIds.has(normalizeId(user.id));
  const emailMatch = emails.size === 0 || emails.has(normalizeEmail(user.email));

  return clientMatch && userMatch && emailMatch;
};

export const canViewApiKeysSurface = (user) => {
  if (!isApiKeysSurfaceEnabled() || !user) return false;
  if (user.oem_id) return false;
  if (API_KEYS_SURFACE_DEFAULT_ROLES.has(user.role)) return true;
  if (hasRuntimePermission(user)) return true;
  return isApiKeysSurfaceAllowlisted(user);
};

export const canViewOemApiKeysSurface = (user) => {
  if (!isApiKeysSurfaceEnabled() || !user) return false;
  if (!user.oem_id) return false;
  if (API_KEYS_SURFACE_DEFAULT_ROLES.has(user.role)) return true;
  return hasRuntimePermission(user);
};

export const API_KEYS_SURFACE_ROLES = ["admin", "admin_staff", "client_admin", "staff"];
